import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

type Props = {
  content: string
  className?: string
}

/** 助手消息 Markdown 渲染（GFM：列表、表格、链接等） */
export function ChatMarkdown({ content, className }: Props) {
  if (!content.trim()) return null
  return (
    <div className={className ? `chat-markdown ${className}` : 'chat-markdown'}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </div>
  )
}
